if (!customElements.get('info-details')) {
    customElements.define(
      'info-details',
      class InfoDetails extends HTMLElement {
        constructor() {
            super();
            this.details = null;
        }

        handleClick(event) {
            if(!this.details.contains(event.target)){
                this.details.removeAttribute('open')
            }
        }
  
        connectedCallback() {
            this.details = this.querySelector('details')
            document.addEventListener('click', this.handleClick.bind(this))
        }

        disconnectedCallback() {
            document.removeEventListener('click', this.handleClick.bind(this))
        }
      }
    );
}